/**
 * 验证码清洗：NFKC 归一化（全角数字→半角）后仅保留数字。
 *
 * 为什么需要：后端 UserServiceImpl 的校验是裸 equals(storedCode, reqCode)，
 * 用户从邮件里复制验证码常带首尾空格/换行，输入法也可能给出全角数字，
 * 这些都会让一个本该通过的验证码失败，并且失败会递增 EMAIL_KEY_ERR_LIMIT，
 * 满 5 次直接删码 —— 用户体验是"重发再错就走"。
 *
 * 用 [^0-9] 而不是 \D：\D 在部分运行时会把某些 Unicode 数字类字符判为数字，
 * 这里要的是"只留 ASCII 0-9"这个确定语义。
 */
export function sanitizeCode(v: unknown): string {
  if (v === null || v === undefined) return ''
  return String(v).normalize('NFKC').replace(/[^0-9]/g, '')
}
